import React, { useEffect } from "react"; 
import { getLoggedInUserGUID, getTimeZoneID, getTimeZoneText, GetAssessmentName } from '../../../../src/web/components/utils';
import { useNavigate } from 'react-router-dom';
import Dashboard from '../../../../src/web/assets/img/icons/menu-icon-01.svg';
import MyProfile from '../../../../src/web/assets/img/icons/menu-icon-02.svg';
import MyPatients from '../../../../src/web/assets/img/icons/menu-icon-03.svg';
import MyAppoinments from '../../../../src/web/assets/img/icons/menu-icon-04.svg';
import MySchedule from '../../../../src/web/assets/img/icons/menu-icon-05.svg';
import iconLogout from '../../../../src/web/assets/img/icons/logout.svg';

interface RouteProps { }
const SideBar: React.FC<RouteProps> = React.memo((): JSX.Element => {
    let navigate = useNavigate();

    const logoutUser = () => {
        // localStorage.removeItem('userData');
        localStorage.clear();
        navigate('/');
        // navigate('/doctor');
        // window.location.href = '/';
        // window.location.reload();
    };

    return (
        <div className="sidebar" id="sidebar">
            <div className="sidebar-inner slimscroll">
                <div id="sidebar-menu" className="sidebar-menu">
                    <ul>
                        <li className="submenu">
                            <a onClick={() => navigate('/dashboard')}>
                                <span className="menu-side">
                                    <img src={Dashboard} alt="" /></span> <span> Dashboard </span>
                            </a>
                        </li>
                        <li className="">
                            <a onClick={() => navigate(`/my-profile/${getLoggedInUserGUID()}?v=true`)}><span className="menu-side">
                                <img src={MyProfile} alt="" /></span> <span> My Profile </span>
                            </a>
                        </li>
                        <li className="submenu">
                            <a onClick={() => navigate('/assessment-template')}><span className="menu-side">
                                <img src={MyAppoinments} alt="" /></span> <span> My Templates </span> </a>
                        </li>
                        <li className="">
                            <a onClick={() => navigate('/patient-list')}><span className="menu-side">
                                <img src={MyPatients} alt="" /></span> <span>My Patients </span>
                            </a>
                        </li>
                        <li className="submenu">
                            <a onClick={() => navigate('/my-appoinment')}><span className="menu-side">
                                <img src={MyAppoinments} alt="" /></span> <span> My Appointments </span> </a>
                        </li>
                        <li className="submenu">
                            <a onClick={() => navigate('/my-schedule')}>
                                <span className="menu-side">
                                    <img src={MySchedule} alt="" />
                                </span>
                                <span> My Schedule </span>
                            </a>
                        </li>
                        <li>
                            <a onClick={() => navigate('/my-workingcalendar')}>
                                <span className="menu-side">
                                    <img src={MyAppoinments} alt="" />
                                </span>
                                <span>My Working Calendar</span>
                            </a>
                        </li>
                    </ul>
                    <div className="logout-btn">
                        <a onClick={() => logoutUser()}>
                            <span className="menu-side">
                                <img src={iconLogout} alt="" />
                            </span>
                            <span>Logout</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default SideBar;